import { Injectable } from '@angular/core';
import { IdiomaModel } from 'src/app/shared/models/idioma.model';

@Injectable({
    providedIn: 'root'
})

export class IdiomaService {
    idiomaSelecionado;
    idiomas;

    constructor() {
        this.idiomas = IdiomaModel.carregarIdiomas();
    }

    setIdioma(idiomaSelecionado) {
        this.idiomaSelecionado = idiomaSelecionado;
    }

    getIdioma() {
        return this.idiomaSelecionado;
    }

    getIdiomas() {
        return this.idiomas;
    }
}
